/**
 * Statut opérationnel admin (≠ statut DB Prisma `StatutPassageAbonnement`).
 * Sync: copie identique dans `backend/src/domain/planning/operationalPassageStatus.ts`.
 */

export type OperationalStatusTone = "danger" | "warning" | "neutral" | "success";

/** Ordre d’affichage / priorité métier : 1 bloqué → 2 retard → 3 urgence → … */
export const OPERATIONAL_PASSAGE_STATUS_VALUES = [
  "BLOCKED",
  "OVERDUE",
  "URGENT",
  "TO_ASSIGN",
  "TEAM_PROPOSED",
  "TEAM_ASSIGNED",
  "ASSIGNED_TOURNEE",
  "IN_PROGRESS",
  "PLANNED",
  "CONFIRMED",
  "PENDING_VALIDATION",
  "DONE",
  "CLOSED_WITH_ANOMALIES",
] as const;

export type OperationalPassageStatus = (typeof OPERATIONAL_PASSAGE_STATUS_VALUES)[number];

type OperationalStatusMeta = {
  labelFr: string;
  tone: OperationalStatusTone;
  /** Plus petit = plus prioritaire à l’affichage. */
  priority: number;
};

export const OPERATIONAL_STATUS_META = {
  BLOCKED: { labelFr: "Bloqué par passage antérieur", tone: "warning", priority: 1 },
  OVERDUE: { labelFr: "En retard à traiter", tone: "danger", priority: 2 },
  URGENT: { labelFr: "Urgence à traiter", tone: "danger", priority: 3 },
  TO_ASSIGN: { labelFr: "À affecter", tone: "warning", priority: 4 },
  TEAM_PROPOSED: { labelFr: "Équipe proposée / À confirmer", tone: "warning", priority: 5 },
  TEAM_ASSIGNED: { labelFr: "Équipe confirmée / À mettre en tournée", tone: "neutral", priority: 6 },
  ASSIGNED_TOURNEE: { labelFr: "Affecté à tournée", tone: "neutral", priority: 7 },
  IN_PROGRESS: { labelFr: "En cours", tone: "neutral", priority: 8 },
  PLANNED: { labelFr: "Planifié", tone: "neutral", priority: 9 },
  CONFIRMED: { labelFr: "Confirmé", tone: "neutral", priority: 10 },
  PENDING_VALIDATION: { labelFr: "En attente validation", tone: "warning", priority: 11 },
  DONE: { labelFr: "Réalisé", tone: "success", priority: 12 },
  CLOSED_WITH_ANOMALIES: { labelFr: "Clôturé avec anomalies", tone: "warning", priority: 13 },
} as const satisfies Record<OperationalPassageStatus, OperationalStatusMeta>;

export const OPERATIONAL_STATUS_FILTER_VALUES = ["ALL", ...OPERATIONAL_PASSAGE_STATUS_VALUES] as const;

export type OperationalPassageStatusFilter = (typeof OPERATIONAL_STATUS_FILTER_VALUES)[number];

export const OPERATIONAL_FILTER_ALL_LABEL_FR = "Tous";

export function defaultLabelForOperationalStatus(status: OperationalPassageStatus): string {
  return OPERATIONAL_STATUS_META[status].labelFr;
}

export function defaultToneForOperationalStatus(status: OperationalPassageStatus): OperationalStatusTone {
  return OPERATIONAL_STATUS_META[status].tone;
}

export const OPERATIONAL_BLOCKED_LABEL_PROVISION_ONLY_FR = "Provision en attente";

export function operationalBlockedCombinedLabelFr(): string {
  return `${OPERATIONAL_STATUS_META.BLOCKED.labelFr} — ${OPERATIONAL_BLOCKED_LABEL_PROVISION_ONLY_FR.toLowerCase()}`;
}
